/**
 * DM Thread List Component
 * List of DM threads for sidebar display
 */

import { useState } from 'react';
import { useDMThreads } from '@/hooks/useDMs';
import DMThreadItem from './DMThreadItem';

const SIDEBAR_LIMIT = 6;

const DMThreadList = () => {
  const { data: threads, isLoading, error } = useDMThreads();
  const [showAll, setShowAll] = useState(false);

  if (isLoading) {
    return (
      <div className="px-2 space-y-1">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-12 bg-gray-800/50 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-2 py-2">
        <div className="text-xs text-red-400">
          Грешка при зареждане
        </div>
      </div>
    );
  }

  if (!threads || threads.length === 0) {
    return (
      <div className="text-xs text-gray-500 text-center py-3">
        Няма съобщения
      </div>
    );
  }

  const visibleThreads = showAll ? threads : threads.slice(0, SIDEBAR_LIMIT);
  const hasMore = threads.length > SIDEBAR_LIMIT;

  return (
    <div className="px-2 space-y-0.5">
      {visibleThreads.map((thread) => (
        <DMThreadItem key={thread.id} thread={thread} />
      ))}
      {hasMore && !showAll && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setShowAll(true);
          }}
          className="w-full text-[11px] text-dark-text-muted hover:text-gray-200 py-1.5 text-center transition-colors"
        >
          Виж всички ({threads.length})
        </button>
      )}
    </div>
  );
};

export default DMThreadList;
